import Base from "./Base";

class Password extends Base {
  constructor(...args) {
    super(...args);
    this.inputType = "password";
    this.inputClass = "password";
  }
}

export default Password;



// WEBPACK FOOTER //
// ./src/components/Form/Input/Password.js